export default function handleOnChangeRelianceIPAHelper(
  event,
  setFieldValue,
  formikValues,
  arrayIndex
) {
  const name = event.target.name;
  const value = event.target.value;

  if (name === "proposerDetails.KYCDetails.SelectOption") {
    if (value === "PASSPORT") {
      const passportNo = formikValues?.proposerDetails?.PassportNumber ?? "";
      setFieldValue("proposerDetails.KYCDetails.PASSPORT", passportNo);
    } else if (value === "PAN") {
      const panNo = formikValues?.proposerDetails?.PanNo ?? "";
      const dob = formikValues?.proposerDetails?.DOB ?? "";
      setFieldValue("proposerDetails.KYCDetails.PAN", panNo);
      setFieldValue("proposerDetails.KYCDetails.DOB", dob);
    } else if (value === "AADHAAR_NO") {
      const aadharNumber = formikValues?.proposerDetails?.AadharNumber ?? "";
      const dob = formikValues?.proposerDetails?.DOB ?? "";
      const foreName = (formikValues?.proposerDetails?.ForeName ?? "").trim();
      const midName = (formikValues?.proposerDetails?.MidName ?? "").trim();
      const lastName = (formikValues?.proposerDetails?.LastName ?? "").trim();

      const fullName = [foreName, midName, lastName].filter(Boolean).join(" ");
      const mobileNo = formikValues?.proposerDetails?.MobileNo ?? "";
      const gender =
        (formikValues?.proposerDetails?.Gender ?? "") === "0"
          ? "M"
          : (formikValues?.proposerDetails?.Gender ?? "") === "1"
          ? "F"
          : "";
      console.log("gender: ", gender);

      setFieldValue("proposerDetails.KYCDetails.AADHAAR_NO", aadharNumber);
      setFieldValue("proposerDetails.KYCDetails.DOB", dob);
      setFieldValue("proposerDetails.KYCDetails.FULLNAME", fullName);
      setFieldValue("proposerDetails.KYCDetails.MOBILE", mobileNo);
      setFieldValue("proposerDetails.KYCDetails.GENDER", gender);
    } else if (value === "VOTERID") {
      const voterID =
        formikValues?.proposerDetails?.AdditionalInformation?.VoterId ?? "";
      setFieldValue("proposerDetails.KYCDetails.VOTERID", voterID);
    }
  }
}
